import { render, staticRenderFns } from "./platformNews.vue?vue&type=template&id=a470fe52&scoped=true&"
import script from "./platformNews.vue?vue&type=script&lang=js&"
export * from "./platformNews.vue?vue&type=script&lang=js&"
import style0 from "./platformNews.vue?vue&type=style&index=0&id=a470fe52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a470fe52",
  null
  
)

export default component.exports